import Loading from 'quasar/src/plugins/loading/Loading.js';
import { routeManager } from "src/router/RouteManager";
import { defineComponent, ref } from "vue";
import { onBeforeRouteUpdate, useRoute, useRouter } from "vue-router";
import { adminApi } from "~/api/admin/Api";
import { api } from "~/api/index";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { MsgBox } from "~/components/MsgBox";
import MypageBadge from "~/components/MypageBadge.vue";
import { auth } from "~/core/Auth";
import { Log } from "~/extensions/utils";
import { CookieHelper } from "~/extensions/utils/CookieHelper";
import { HanyoKb, InformationDetailBeforeRouteKbn, PageID } from "~/extensions/utils/DefineTypes";
import { commonStore } from "~/store/CommonStore";
import { myPageStore } from "~/store/MyPageStore";
import { NyukyoshaViewModel } from "./Models/NyukyoshaViewModel";
const log = Log.create("NyukyoshaDetail");
export default defineComponent({
    name: "NyukyoshaDetail",
    components: {
        MypageBadge,
        BreadcrumbList
    },
    async setup() {
        const pageName = commonStore.pageName(PageID.nyukyoshaDetail);
        const top = PageID.top;
        const nyukyoshaList = PageID.nyukyoshaList;
        const nyukyoshaDetail = PageID.nyukyoshaDetail;
        const nyukyoData = ref(new NyukyoshaViewModel());
        const router = useRouter();
        const route = useRoute();
        let urlParameters = Number(route.query.nyukyokeiyakuNo);
        let visibleLoginComfirmDialog = ref(false);
        const PI0009 = commonStore.messages.PI0009;
        const PI0010 = commonStore.messages.PI0010;
        // 入居状況区分
        const NyukyoKbn = HanyoKb.NyukyoKb;
        // 回答状況区分
        const ResponsesContentKbn = HanyoKb.ResponsesContentKbn;
        const isHeadquarters = ref(auth.userInfo.isHeadquarters);
        // 証明書発行状況テーブルカラム
        const shomeiColumns = [
            { name: "shomeiNo", label: "申込番号", align: "left", field: "shomeiNo", sortable: true },
            { name: "shomeiKbName", label: "証明書名", align: "left", field: "shomeiKbName", sortable: true },
            { name: "shinseiYmd", label: "申請日", align: "center", field: "shinseiYmd", sortable: true },
            { name: "shomeiStatusName", label: "発行状況", align: "left", field: "shomeiStatusName", sortable: true },
            { name: "shomeiBikou", label: "備考", align: "left", field: "shomeiBikou", sortable: true }
        ];
        // お知らせ情報テーブルカラム
        const informationColumns = [
            { name: "weight", label: "重要", align: "center", field: "weight", sortable: true },
            { name: "Readed", label: "確認", align: "center", field: "readed", sortable: true },
            { name: "responseContent", label: "回答", align: "center", field: "responseContent", sortable: true },
            { name: "startAt", label: "掲載開始日", align: "center", field: "startAt", sortable: true },
            { name: "endAt", label: "掲載終了日", align: "center", field: "endAt", sortable: true },
            { name: "subject", label: "タイトル", align: "left", field: "subject", sortable: true }
        ];
        //身上書確認押下時の処理
        const onClickShinjosho = () => {
            router.push({ name: "shinjosho-edit", query: { nyukyokeiyakuNo: nyukyoData.value.orgNyukyokeiyakuNo } });
        };
        //証明書名リンク押下時の処理
        const onClickShomei = (shomeiNo) => {
            router.push({ name: "shomei-shinsei-entry-check", query: { nyukyokeiyakuNo: urlParameters, shomeiNo: shomeiNo, orgNyukyokeiyakuNo: nyukyoData.value.orgNyukyokeiyakuNo } });
        };
        //お知らせ情報行押下時の処理
        const onClickInformation = (informationNo) => {
            CookieHelper.set("informationDetailBeforeRoute", InformationDetailBeforeRouteKbn.NyukyoshaDetail.toString());
            router.push({ name: "information-detail", query: { informationNo: informationNo } });
        };
        const toListPage = () => {
            router.push({ name: "nyukyosha-list" });
        };
        const onClickLoginConfirmDialog = async () => {
            try {
                visibleLoginComfirmDialog.value = false;
                Loading.show({ customClass: "low-transparency-loading" });
                await api.auth.impersonation(urlParameters, nyukyoData.value.userCd, nyukyoData.value.lifeKainNo);
                auth.logoutLocal();
                myPageStore.clear();
                await auth.init();
                await commonStore.init();
                myPageStore.load();
                await myPageStore.waitForBasic();
                if (myPageStore.loadError) {
                    throw new Error(commonStore.messages.PE0003);
                }
                routeManager.initRoute(router);
                await router.push({ name: "top" });
            }
            catch (ex) {
                await MsgBox.error(ex.data.errorMessage);
                log.error("impersonation", ex);
            }
            finally {
                Loading.hide();
            }
            // 最新情報取得に失敗した場合はなりすまし終了
            if (myPageStore.loadError) {
                await endImpersonation();
            }
        };
        const endImpersonation = async () => {
            try {
                Loading.show();
                let nyukyokeiyakuNo = auth.userInfo.impersonationNyukyoNo;
                await api.auth.endImpersonation();
                auth.logoutLocal();
                myPageStore.clear();
                await auth.init();
                routeManager.initRoute(router);
                await router.push({ name: "nyukyosha-detail", query: { nyukyokeiyakuNo: nyukyokeiyakuNo } });
            }
            catch (ex) {
                await MsgBox.error(ex.data.errorMessage);
                log.error("endImpersonation", ex);
            }
            finally {
                Loading.hide();
            }
        };
        /**ルートを書き換えた場合の処理 */
        onBeforeRouteUpdate(async (to, from) => {
            if (to.query.nyukyokeiyakuNo !== from.query.nyukyokeiyakuNo) {
                urlParameters = Number(to.query.nyukyokeiyakuNo);
                try {
                    let nyukyoshaData = await adminApi.nyukyosha.get(urlParameters);
                    nyukyoData.value = new NyukyoshaViewModel(nyukyoshaData);
                }
                catch (ex) {
                    await MsgBox.error(ex.data.errorMessage);
                    log.error("find", ex);
                }
            }
        });
        // 初期表示処理
        try {
            let nyukyoshaData = await adminApi.nyukyosha.get(urlParameters);
            nyukyoData.value = new NyukyoshaViewModel(nyukyoshaData);
        }
        catch (ex) {
            await MsgBox.error(ex.data.errorMessage);
            log.error("find", ex);
        }
        return {
            nyukyoData,
            NyukyoKbn,
            ResponsesContentKbn,
            visibleLoginComfirmDialog,
            PI0009,
            PI0010,
            isHeadquarters,
            pageName,
            top,
            nyukyoshaList,
            nyukyoshaDetail,
            shomeiColumns,
            informationColumns,
            onClickShinjosho,
            onClickShomei,
            onClickInformation,
            toListPage,
            onBeforeRouteUpdate,
            onClickLoginConfirmDialog
        };
    }
});
